/**
 * Who supplied a patient's insurance record. primary owns this vocabulary — the insurance record
 * stores it, constrained to these values in the database, and defaults to `Ehr`.
 */
export var InsuranceSource;
(function (InsuranceSource) {
    InsuranceSource["Patient"] = "PATIENT";
    InsuranceSource["Ehr"] = "EHR";
})(InsuranceSource || (InsuranceSource = {}));
//# sourceMappingURL=source.js.map